var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06057 17.54L-7.53516e-07 15.4794C5.22681 10.4536 10.0013 5.37758 14.5748 -4.45178e-06C19.3493 5.52836 24.1237 10.6044 29.1495 15.4794L27.089 17.54L19.9021 9.69976C17.6907 7.33764 16.0322 5.32733 16.0322 5.32733C16.0322 5.32733 16.0825 7.99099 16.0825 11.2075L16.0825 32.7178L13.1173 32.7178L13.1173 11.1572C13.1173 7.94073 13.2178 5.37758 13.2178 5.37758C13.2178 5.37758 11.4588 7.33764 9.29769 9.75001L2.06057 17.54Z",
    fill: "#040626"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36523,
    y: 15.1888,
    width: 2.59961,
    height: 17.3853,
    fill: "#040626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7871,
    y: 29.9745,
    width: 2.59961,
    height: 23.1216,
    transform: "rotate(90 25.7871 29.9745)",
    fill: "#040626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7871,
    y: 15.1888,
    width: 2.59961,
    height: 17.3853,
    fill: "#040626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSymbol);
export default __webpack_public_path__ + "static/media/home_symbol.64e299464d504ae2b7565ef4736f4e62.svg";
export { ForwardRef as ReactComponent };